<template>
  <div class="label-legend"><slot /></div>
</template>

<script>
export default {
  name: "AppLabel"
}
</script>
